import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import ClickIcon from "../../components/essentials/icon-buttons/click-icon/ClickIcon";
import Post from "../../components/post/Post";
import http from "../../shared/utils/http";
import "./PostPage.scss";

export interface PostPageProps {
  postId?: string;
  closePostPage?: () => void;
}

const PostPage: React.FC<PostPageProps> = ({ postId, closePostPage }) => {
  console.log("postId", postId);
  let params = useParams();
  if (!postId && params.postId) postId = params.postId;

  const [postInfo, setPostInfo] = useState();

  useEffect(() => {
    http
      .get(`/post/${postId}`)
      .then((res) => {
        setPostInfo(res);
      })
      .catch(() => {});
  }, [postId]);

  return postInfo ? (
    <div className="post-page-container">
      <div className="post-page">
        <Post onDeletePost={() => {}} postInfo={postInfo} />
        {closePostPage && (
          <div className="back-arrow">
            <ClickIcon icon="backarrow" size="l" onClick={closePostPage} />
          </div>
        )}
      </div>
    </div>
  ) : (
    <p>error page</p>
  );
};
export default PostPage;
